import { PartialEnvVarMap } from "../types/envVar";

// Tour2: the PIM API behind the Tour2 public edge (terrasaur identity-management/tour2)
// and the Tour2 CIAM Okta org (okta-server tour, workspace okta-server-tour-new).
const tour2EnvVars: PartialEnvVarMap = {
  idApiUrl: "https://identity-management.tour.justworks.com",
  oktaAppClientId: "0oa22j5n2wtxkUFoo1d8",
  oktaHostUrl: "https://login.tour.justworks.com",
  oktaCommonJwGroupId: "00g22j5t5cwUVEv4q1d8",
};

export default tour2EnvVars;
